<script setup lang="ts">
import { computed } from "vue";

import type { ClausensArticle } from "./types";

const props = defineProps<{
  article: ClausensArticle;
}>();

const translations = computed<string>(() =>
  props.article.meanings
    .flatMap((meaning) => meaning.translations)
    .map((translation) => translation.translation)
    .filter((translation, index, self) => self.indexOf(translation) === index)
    .join(", ")
);
</script>

<template>
  <div class="le-article-body-collapsed">
    <span class="le-article-body-collapsed__translations">
      {{ translations }}
    </span>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
@import "@/assets/styles/dictsys-article";

.le-article-body-collapsed {
  &__translations {
    .dictsys-article-text();
  }
}
</style>
